import React from "react";

interface FeatureCard {
  icon: string;
  title: string;
  description: string;
}

interface FeatureCardsProps {
  features?: FeatureCard[];
}

const defaultFeatures: FeatureCard[] = [
  {
    icon: "🎯",
    title: "Natural Language Search",
    description:
      "Search using everyday language - from specific features to neighborhood vibes.",
  },
  {
    icon: "🤖",
    title: "AI-Powered Understanding",
    description:
      "Our AI understands context, preferences, and even lifestyle needs to find your perfect match.",
  },
  {
    icon: "⚡",
    title: "Smart Results",
    description:
      "Get personalized property recommendations that truly match your unique requirements.",
  },
];

export const FeatureCards: React.FC<FeatureCardsProps> = ({
  features = defaultFeatures,
}) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 lg:gap-12">
      {features.map((feature, index) => (
        <div
          key={feature.title}
          className="group relative p-4 py-6 sm:p-5 lg:p-7 bg-white rounded-2xl border border-gray-100 hover:border-gray-200 transition-all duration-300 shadow-md hover:shadow-xl hover:-translate-y-1"
        >
          <div className="flex flex-col items-center text-center space-y-4">
            <div className="flex items-center justify-center w-12 h-12 sm:w-14 sm:h-14 lg:w-16 lg:h-16 text-2xl sm:text-2xl lg:text-3xl rounded-xl bg-primary group-hover:scale-110 transition-transform duration-300">
              {feature.icon}
            </div>
            <h3 className="text-base sm:text-lg lg:text-xl font-bold text-gray-900">
              {feature.title}
            </h3>
            <p className="text-sm lg:text-base text-gray-600 leading-relaxed">
              {feature.description}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default FeatureCards;
